import { FormRow, FormSection } from 'framework/ui/layout';
import { DateInput } from 'framework/form';
import { useDateService, DATE_FORMAT } from 'framework/utils';
import CostsStructureDetailsSection from '../../shared/inputs/CostsStructureDetailsSection';

const ServiceCostsStructureForm = () => {
  const { getToday } = useDateService();

  return (
    <>
      <FormSection>
        <FormRow>
          <DateInput
            dateFormat={DATE_FORMAT.API_ONLY_MONTH}
            minDate={getToday()}
            source="effectiveDate"
            label="Effective Date"
            isRequired
          />
        </FormRow>
      </FormSection>
      <FormSection>
        <CostsStructureDetailsSection />
      </FormSection>
    </>
  );
};

export default ServiceCostsStructureForm;
